import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var HorizontalNavigationCss = i`
  .navigation-item {
    font-family: var(--isceco-font);
    display: inline-flex;
    padding: var(--isceco-space-300);
    cursor: pointer;
  }

  .desktop .navigation-item {
    border-bottom: 3px solid transparent;
  }

  .mobile {
    display: none;
    text-align: right;
  }

  .mobile > div {
    display: none;
    text-align: left;
    margin-left: 3px;
  }

  .mobile .navigation-item {
    border-left: 3px solid transparent;
  }

  nav {
    background-color: var(--isceco-color-white-500);
  }

  .desktop {
    padding-inline: 90px;
  }

  .desktop .navigation-item:hover:not(.active) {
    border-bottom: 3px solid var(--isceco-color-red-500);
  }

  .desktop .navigation-item.active {
    background-color: var(--isceco-color-background);
    border-bottom: 3px solid var(--isceco-color-red-500);
    font-weight: bold;
  }

  .mobile .navigation-item:hover:not(.active) {
    border-left: 3px solid var(--isceco-color-red-500);
  }

  .mobile .navigation-item.active {
    border-left: 3px solid var(--isceco-color-white-500);
    background-color: var(--isceco-color-background);
    font-weight: bold;
  }

  .hamburger-menu {
    border: none;
    cursor: pointer;
    background: transparent;
    padding: var(--isceco-space-200);
  }

  .hamburger-menu:hover {
    color: var(--isceco-color-black-500);
  }

  .hamburger-menu:focus {
    outline: none;
    box-shadow: none;
  }

  .hamburger-menu i {
    font-size: 1.25rem;
  }

  @media (max-width: 991.98px) {
    .desktop {
      display: none;
    }

    .mobile {
      display: block;
      background-color: var(--isceco-color-white-500);
    }

    .show, .show .navigation-item {
      display: block !important;
    }

    .navigation-item {
      border-bottom: 2px solid var(--isceco-color-background);
      background-color: var(--isceco-color-white-500);
      padding: var(--isceco-space-200);
    }
  }
`;
export { HorizontalNavigationCss as default };
